import { AritoIcon } from '@/components/custom/arito/icon';
import { NavMenu } from '../types';
export const tienGuiMenu: NavMenu = {
  title: 'Tiền gửi',
  items: [
    {
      title: 'Hạch toán',
      items: [
        {
          title: 'Giấy báo có',
          icon: <AritoIcon icon={845} />,
          href: '/tien-gui/hach-toan/giay-bao-co',
          group: 0
        },
        {
          title: 'Giấy báo nợ',
          icon: <AritoIcon icon={846} />,
          href: '/tien-gui/hach-toan/giay-bao-no',
          group: 0
        }
      ]
    },
    {
      title: 'Đề nghị thanh toán',
      items: [
        {
          title: 'Cập nhật đề nghị thanh toán',
          href: '/tien-gui/de-nghi-thanh-toan/cap-nhat-de-nghi-thanh-toan',
          group: 1
        },
        {
          title: 'Duyệt đề nghị thanh toán',
          href: '/tien-gui/de-nghi-thanh-toan/duyet-de-nghi-thanh-toan',
          group: 1
        }
      ]
    },
    {
      title: 'Tạo phiếu thu từ hóa đơn',
      icon: <AritoIcon icon={200} />,
      href: '/tien-gui/tao-phieu-thu-tu-hoa-don',
      group: 1
    },
    {
      title: 'Tạo phiếu chi từ hóa đơn',
      icon: <AritoIcon icon={198} />,
      href: '/tien-gui/tao-phieu-chi-tu-hoa-don',
      group: 1
    },
    {
      title: 'Sổ quỹ',
      items: [
        {
          title: 'Sổ tiền gửi ngân hàng',
          icon: <AritoIcon icon={542} />,
          href: '/tien-gui/so-quy/so-tien-gui-ngan-hang'
        },
        {
          title: 'Sổ nhật ký thu tiền',
          icon: <AritoIcon icon={548} />,
          href: '/tien-gui/so-quy/so-nhat-ky-thu-tien'
        },
        {
          title: 'Sổ nhật ký chi tiền',
          icon: <AritoIcon icon={546} />,
          href: '/tien-gui/so-quy/so-nhat-ky-chi-tien'
        },
        {
          title: 'Báo cáo số dư tại quỹ của ngân hàng',
          icon: <AritoIcon icon={775} />,
          href: '/tien-gui/so-quy/bao-cao-so-du-tai-quy-cua-ngan-hang',
          group: 0
        }
      ],
      group: 2
    }
  ]
};
